import React, { useEffect, useState } from "react";

// Brief branded splash shown once per session when the app is launched as an
// installed PWA (standalone display mode). Never shows in a normal browser tab.
export default function InstallSplash() {
  const isStandalone =
    typeof window !== "undefined" &&
    ((window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
      window.navigator.standalone === true);

  const [visible, setVisible] = useState(
    isStandalone && typeof sessionStorage !== "undefined" && !sessionStorage.getItem("sam_splash_shown")
  );
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem("sam_splash_shown", "1");
    const f = setTimeout(() => setFade(true), 900);
    const h = setTimeout(() => setVisible(false), 1500);
    return () => { clearTimeout(f); clearTimeout(h); };
  }, [visible]);

  if (!visible) return null;
  return (
    <div data-testid="install-splash"
      className={`fixed inset-0 z-[9999] grid place-items-center bg-sam-navy transition-opacity duration-500 ${fade ? "opacity-0" : "opacity-100"}`}>
      <div className="flex flex-col items-center">
        <img src="/sam-logo.png" alt="Saving America Money" className="h-24 w-24 object-contain animate-pulse" />
        <div className="mt-4 font-display font-extrabold tracking-wide text-sam-cream text-lg">SAVING AMERICA MONEY</div>
        <div className="mt-1 text-sam-cream/60 text-sm">Shop local · Save local</div>
      </div>
    </div>
  );
}
